import produce from 'immer';

import types from './types';

export const INITIAL_STATE = {
  functions: { data: [], error: false, loading: true },
  foundFunctions: { data: [], error: false, loading: true },
  isLoadingFunctionMutation: false,
  instructions: { data: [], error: false, loading: true },
  foundInstructions: { data: [], error: false, loading: true },
};

export default function ivrAIAgent(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.FETCH_IVR_AI_AGENT_FUNCTIONS: {
        draft.functions.error = false;
        draft.functions.loading = true;
        break;
      }
      case types.FETCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS: {
        const data = action.payload;
        draft.functions = { error: false, loading: false, data };
        break;
      }
      case types.FETCH_IVR_AI_AGENT_FUNCTIONS_FAILURE: {
        draft.functions = { error: true, loading: false };
        break;
      }

      case types.SEARCH_IVR_AI_AGENT_FUNCTIONS: {
        draft.foundFunctions.error = false;
        draft.foundFunctions.loading = true;
        break;
      }
      case types.SEARCH_IVR_AI_AGENT_FUNCTIONS_SUCCESS: {
        const data = action.payload;
        draft.foundFunctions = { error: false, loading: false, data };
        break;
      }
      case types.SEARCH_IVR_AI_AGENT_FUNCTIONS_FAILURE: {
        draft.foundFunctions = { error: true, loading: false };
        break;
      }

      case types.CREATE_IVR_AI_AGENT_FUNCTION: {
        draft.isLoadingFunctionMutation = true;
        break;
      }
      case types.CREATE_IVR_AI_AGENT_FUNCTION_SUCCESS: {
        const pageLimit = state.foundFunctions?.data?.limit || 10;
        draft.isLoadingFunctionMutation = false;
        draft.foundFunctions.data.items = [
          action.payload,
          ...(state.foundFunctions.data?.items || []),
        ].slice(0, pageLimit);
        break;
      }
      case types.CREATE_IVR_AI_AGENT_FUNCTION_FAILURE: {
        draft.isLoadingFunctionMutation = false;
        break;
      }

      case types.UPDATE_IVR_AI_AGENT_FUNCTION: {
        draft.isLoadingFunctionMutation = true;
        break;
      }
      case types.UPDATE_IVR_AI_AGENT_FUNCTION_SUCCESS: {
        draft.isLoadingFunctionMutation = false;
        draft.foundFunctions.data.items =
          state.foundFunctions.data?.items?.map?.((item) =>
            item._id === action.payload._id
              ? { ...item, ...action.payload }
              : item
          );
        break;
      }
      case types.UPDATE_IVR_AI_AGENT_FUNCTION_FAILURE: {
        draft.isLoadingFunctionMutation = false;
        break;
      }

      case types.DELETE_IVR_AI_AGENT_FUNCTION: {
        draft.isLoadingFunctionMutation = true;
        break;
      }
      case types.DELETE_IVR_AI_AGENT_FUNCTION_SUCCESS: {
        draft.isLoadingFunctionMutation = false;
        draft.foundFunctions.data.items =
          state.foundFunctions.data?.items?.filter(
            (item) => item._id !== action.payload.id
          );
        break;
      }
      case types.DELETE_IVR_AI_AGENT_FUNCTION_FAILURE: {
        draft.isLoadingFunctionMutation = false;
        break;
      }

      case types.FETCH_IVR_AI_AGENT_INSTRUCTIONS: {
        draft.instructions.error = false;
        draft.instructions.loading = true;
        break;
      }
      case types.FETCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS: {
        const data = action.payload;
        draft.instructions = { error: false, loading: false, data };
        break;
      }
      case types.FETCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE: {
        draft.instructions = { error: true, loading: false };
        break;
      }

      case types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS: {
        draft.foundInstructions.error = false;
        draft.foundInstructions.loading = true;
        break;
      }
      case types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS_SUCCESS: {
        const data = action.payload;
        draft.foundInstructions = { error: false, loading: false, data };
        break;
      }
      case types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS_FAILURE: {
        draft.foundInstructions = { error: true, loading: false };
        break;
      }

      case types.CREATE_IVR_AI_AGENT_INSTRUCTION: {
        draft.isLoadingFunctionMutation = true;
        break;
      }
      case types.CREATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS: {
        const pageLimit = state.foundInstructions?.data?.limit || 10;
        draft.isLoadingFunctionMutation = false;
        draft.foundInstructions.data.items = [
          action.payload,
          ...(state.foundInstructions.data?.items || []),
        ].slice(0, pageLimit);
        break;
      }
      case types.CREATE_IVR_AI_AGENT_INSTRUCTION_FAILURE: {
        draft.isLoadingFunctionMutation = false;
        break;
      }

      case types.UPDATE_IVR_AI_AGENT_INSTRUCTION: {
        draft.isLoadingFunctionMutation = true;
        break;
      }
      case types.UPDATE_IVR_AI_AGENT_INSTRUCTION_SUCCESS: {
        draft.isLoadingFunctionMutation = false;
        draft.foundInstructions.data.items =
          state.foundInstructions.data?.items?.map?.((item) =>
            item._id === action.payload._id
              ? { ...item, ...action.payload }
              : item
          );
        break;
      }
      case types.UPDATE_IVR_AI_AGENT_INSTRUCTION_FAILURE: {
        draft.isLoadingFunctionMutation = false;
        break;
      }

      case types.DELETE_IVR_AI_AGENT_INSTRUCTION: {
        draft.isLoadingFunctionMutation = true;
        break;
      }
      case types.DELETE_IVR_AI_AGENT_INSTRUCTION_SUCCESS: {
        draft.isLoadingFunctionMutation = false;
        draft.foundInstructions.data.items =
          state.foundInstructions.data?.items?.filter(
            (item) => item._id !== action.payload.id
          );
        break;
      }
      case types.DELETE_IVR_AI_AGENT_INSTRUCTION_FAILURE: {
        draft.isLoadingFunctionMutation = false;
        break;
      }

      default:
        return state;
    }
  });
}
